import BossModel from "@/models/BossModel";
import Group from "@/models/Proposal/Group/Group";
import Cancellation from "@/models/Proposal/Cancellation/Cancellation";
import CheckState from "@/models/Proposal/CheckState/CheckState";
import DossierTicket from "@/models/Dossier/Ticket/Ticket";

export default class Ticket extends BossModel {

    static apiUrl = 'proposal/ticket';

    static entity = 'proposalTickets';

    static fields() {
        return {
            id: this.number(null).nullable(),
            proposal_group_id: this.number(null).nullable(),
            proposal_cancellation_id: this.number(null).nullable(),
            dossier_ticket_id: this.number(null).nullable(),
            proposal_check_state_id: this.number(null).nullable(),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            group: this.belongsTo(Group, 'proposal_group_id'),
            cancellation: this.belongsTo(Cancellation, 'proposal_cancellation_id'),
            checkState: this.belongsTo(CheckState, 'proposal_check_state_id'),
            dossierTicket: this.belongsTo(DossierTicket, 'dossier_ticket_id'),
        }
    }

    Proposal() {
        if (this.getRelated('group')) {
            return this.getRelated('group').Proposal();
        }

        if (this.getRelated('cancellation')) {
            return this.getRelated('cancellation').Proposal();
        }

        return false;
    }
}
